const initImageGalleryDisplay = (element) => {
  const $gallery = $(element);

  if ($gallery.data('image-gallery-display-initialized')) {
    return;
  }

  $gallery.data('image-gallery-display-initialized', true);

  const $items = $('[data-image-gallery-item]', $gallery);
  const $lightbox = $('[data-image-gallery-lightbox]', $gallery);
  const $lightboxFigure = $('.image-gallery-display-lightbox-figure', $gallery);
  const $lightboxImage = $('[data-image-gallery-lightbox-image]', $gallery);
  const $lightboxCaption = $('[data-image-gallery-lightbox-caption]', $gallery);
  const $toggle = $('[data-image-gallery-toggle]', $gallery);
  const $toggleLabel = $('[data-image-gallery-toggle-label]', $gallery);
  const $closeButton = $('[data-image-gallery-close]', $gallery);
  let currentIndex = 0;

  const imageItems = $items.map(function () {
    return {
      caption: $(this).attr('data-caption') || '',
      src: $(this).attr('data-src'),
    };
  }).get();

  const updateLightboxFigureWidth = () => {
    const image = $lightboxImage.get(0);
    const width = image.getBoundingClientRect().width;

    if (width) {
      $lightboxFigure.css('width', width + 'px');
    }
  };

  const showImage = (index) => {
    currentIndex = (index + imageItems.length) % imageItems.length;
    const item = imageItems[currentIndex];
    $lightboxFigure.css('width', '');
    $lightboxImage.attr({src: item.src, alt: item.caption});
    $lightboxCaption.text(item.caption).attr('title', item.caption);
    window.requestAnimationFrame(updateLightboxFigureWidth);
  };

  const openLightbox = (index) => {
    $lightbox.addClass('is-open').attr('aria-hidden', 'false');
    $('body').addClass('image-gallery-lightbox-open');
    showImage(index);
    $closeButton.trigger('focus');
  };

  const closeLightbox = () => {
    $lightbox.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('image-gallery-lightbox-open');
  };

  $items.on('click', function () {
    openLightbox(Number($(this).data('index')));
  });

  $('[data-image-gallery-close]', $gallery).on('click', closeLightbox);
  $lightboxImage.on('load', updateLightboxFigureWidth);
  $('[data-image-gallery-previous]', $gallery).on('click', () => showImage(currentIndex - 1));
  $('[data-image-gallery-next]', $gallery).on('click', () => showImage(currentIndex + 1));
  $lightbox.on('click', (event) => {
    if (event.target === $lightbox.get(0)) {
      closeLightbox();
    }
  });

  $toggle.on('click', function () {
    const expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', String(!expanded)).toggleClass('is-expanded', !expanded);
    $toggleLabel.text(expanded
      ? $(this).data('view-all-text')
      : $(this).data('show-fewer-text'));
  });

  $(document).on('keydown.image-gallery-display-' + $gallery.data('gallery-id'), (event) => {
    if (!$lightbox.hasClass('is-open')) {
      return;
    }

    if (event.key === 'Escape') {
      closeLightbox();
    } else if (event.key === 'ArrowLeft') {
      showImage(currentIndex - 1);
    } else if (event.key === 'ArrowRight') {
      showImage(currentIndex + 1);
    }
  });
};

const initImageGalleryDisplays = () => {
  $('[data-image-gallery-display]').each(function () {
    initImageGalleryDisplay(this);
  });
};

$(initImageGalleryDisplays);
document.addEventListener('jb.section.rendered', initImageGalleryDisplays);
